import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const SecondPage = () => (
  <Layout>
    <SEO title="What makes a good Product job" />
    <h1>What makes a good Product job?</h1>
    <p>On here, the only kind of jobs you'll find are:</p>
    <ul>
      <li>At a product-centric technology company</li>
      <li>In an empowered Product team, not a feature delivery team</li>
      <li>Focus on the problem being solved and on outcomes over outputs, addressing the key product risks (value / viability / usability / feasibility)</li>
      <li>Working in a truly agile way, where you can take risks that might not pan out</li>
      <li>Where you can - and are expected to - influence others in the company</li>
    </ul>
    <p>Silicon Valley Product Group have a <Link to="https://svpg.com/product-manager-job-description/">job description</Link> that's a great example of what we're looking for.</p>
    <p>No "Product Owner" jobs. No actually-a-project-manager jobs. No mention of SAFe.</p>
    <Link to="/">Back</Link>
  </Layout>
)

export default SecondPage
